import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import type { MailboxInfo } from 'owa-client-types';
import { getAnonymousMailboxInfo } from 'owa-mailbox-info/lib/getAnonymousMailboxInfo';

export function tryGetDefaultMailboxInfo(): MailboxInfo {
    try {
        return getGlobalSettingsAccountMailboxInfo();
    } catch {
        return getAnonymousMailboxInfo();
    }
}
